<nav class="flex items-center text-small text-secondary" aria-label="Migas de pan">
  <!-- Desktop: rastro completo -->
  <div class="hidden items-center md:flex">
    <a class="text-secondary no-underline hover:text-brand hover:underline" routerLink="/"
      >Inicio</a
    >
    @for (crumb of breadcrumbs(); track crumb.url) {
      <mat-icon svgIcon="chevron-right" class="mx-0.5 !h-4 !w-4 text-tertiary"></mat-icon>
      @if ($last) {
        <span class="cursor-default font-medium text-primary" aria-current="page">
          {{ crumb.label }}
        </span>
      } @else {
        <a
          class="text-secondary no-underline hover:text-brand hover:underline"
          [routerLink]="crumb.url"
          >{{ crumb.label }}</a
        >
      }
    }
  </div>

  <!-- Móvil: solo "← nivel anterior" + página actual -->
  <div class="flex items-center gap-1 md:hidden">
    @if (breadcrumbs().length > 1) {
      <a
        class="flex items-center gap-0.5 text-secondary no-underline hover:text-brand"
        [routerLink]="breadcrumbs()[breadcrumbs().length - 2].url"
      >
        <mat-icon svgIcon="chevron-left" class="!h-4 !w-4"></mat-icon>
        {{ breadcrumbs()[breadcrumbs().length - 2].label }}
      </a>
    } @else if (breadcrumbs().length === 1) {
      <a
        class="flex items-center gap-0.5 text-secondary no-underline hover:text-brand"
        routerLink="/"
      >
        <mat-icon svgIcon="chevron-left" class="!h-4 !w-4"></mat-icon>
        Inicio
      </a>
    }
  </div>
</nav>
